import React, { useContext, useEffect } from 'react';

import { Modal } from '../Modal';
import { ModalsContext } from '../../context/ModalsContext';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ScriptsContext } from '../../context/ScriptsContext';

const useStyles = makeStyles(() =>
  createStyles({
    videoPlayer: {
      width: '100%',
      height: '100%',
    },
  }),
);

const VideoModal = () => {
  const classes = useStyles();

  const { isVideoModalOpened, videoModalData, setVideoModalStatus } = useContext(ModalsContext);
  const { isLoadedAnalyticScript } = useContext(ScriptsContext);

  const closeModal = () => {
    if (window) {
      window?.verseEvents?.onVideoClose();
    }

    setVideoModalStatus(false);
  };

  useEffect(() => {
    if (
      isLoadedAnalyticScript &&
      videoModalData?.duration &&
      window?.verseEvents?.changeVideoDuration
    ) {
      window.verseEvents.changeVideoDuration(
        videoModalData.duration,
        videoModalData?.title,
        videoModalData?.expertName,
      );
    }
  }, [videoModalData, isLoadedAnalyticScript]);

  return (
    <Modal toggle={closeModal} isOpened={isVideoModalOpened}>
      <iframe
        title={videoModalData?.url}
        className={classes.videoPlayer}
        src={
          videoModalData?.verseId
            ? `${process.env.REACT_APP_VERSE_PLAYER_URL}/stories/${videoModalData?.verseId}-xunlocked/?embed&controls=2&sharing=0&covertitle=0`
            : videoModalData?.url
        }
        frameBorder="0"
        allowFullScreen
      />
    </Modal>
  );
};

export default VideoModal;
